'use strict';

import { documentReady } from 'Util/util';
import { CONST } from 'app_vodafone_ziggo/util/util';

const classes = {
    active: 'active'
};

const selectors = {
    searchField: '.js-search-field',
    searchForm: '.js-search-form',
    searchTrigger: '.js-search-trigger',
    searchFlyout: '.js-search-flyout'
};

/**
 * @class Search
 * @description Handles search functionality including trigger interactions and flyout management
 */
export default class Search {
    constructor() {
        this.searchField = document.querySelector(selectors.searchField);
        this.searchForm = document.querySelector(selectors.searchForm);
        this.searchTrigger = document.querySelector(selectors.searchTrigger);
        this.searchFlyout = document.querySelector(selectors.searchFlyout);

        this.init();
    }

    /**
     * Initialize search functionality
     */
    init() {
        if (!this.searchForm || !this.searchField || !this.searchFlyout || !this.searchTrigger) {
            return;
        }

        this.bindEvents();
    }

    /**
     * Bind event listeners
     */
    bindEvents() {
        this.searchTrigger.addEventListener(CONST.events.click, this.handleTriggerClick.bind(this));
        document.addEventListener(CONST.events.click, this.handleDocumentClick.bind(this));
        document.addEventListener(CONST.events.keyDown, this.handleKeyDown.bind(this));
    }

    /**
     * Handle search trigger click
     * @param {Event} event - Click event
     */
    handleTriggerClick(event) {
        event.preventDefault();
        event.stopPropagation();

        if (this.isSearchActive()) {
            this.closeSearch();
        } else {
            this.openSearch();
        }
    }

    /**
     * Handle document clicks to close search when clicking outside
     * @param {Event} event - Click event
     */
    handleDocumentClick(event) {
        if (this.isSearchActive() && !this.searchFlyout.contains(event.target) && !this.searchTrigger.contains(event.target)) {
            this.closeSearch();
        }
    }

    /**
     * Handle keydown events
     * @param {Event} event - Keydown event
     */
    handleKeyDown(event) {
        if (event.key === 'Escape' && this.isSearchActive()) {
            event.preventDefault();
            this.closeSearch();
        }
    }

    /**
     * Open search flyout
     */
    openSearch() {
        this.searchFlyout.classList.add(classes.active);
        this.searchTrigger.classList.add(classes.active);
        this.searchField.focus();
    }

    /**
     * Close search flyout
     */
    closeSearch() {
        this.searchFlyout.classList.remove(classes.active);
        this.searchTrigger.classList.remove(classes.active);
        this.searchField.value = '';
    }

    /**
     * Check if search is currently active
     * @returns {boolean} - Whether search flyout is active
     */
    isSearchActive() {
        return this.searchFlyout.classList.contains(classes.active);
    }
}

documentReady(() => {
    // eslint-disable-next-line no-new
    new Search();
});
